export enum AdminDashQuickMode {
    NewContent = "NewContent",
    OutstandingLinks = "OutstandngLinks",
}

export const QuickModePageSize = 25